import React from 'react'
import PropTypes from 'prop-types'
import '@loyal_template/order.css'
import MediaQuery from 'react-responsive'

import { ProductImage } from 'features/ProductImage'
import { ProductDetails } from './ProductDetails'
import { ViewProdutOrderDetail } from './ViewProdutOrderDetail'
import { Link } from 'react-router-dom'

const ProductOrderItem = props => (
  <div className='col-12 px-1 order-item'>
    <Link
      className='mx-0 row px-0 border-color-ui-3 border-dotted-bottom py-2'
      to={`/order/${props.product.parentOrderId}/${props.product.orderId}/product/${
        props.product.id
      }?previousRoute=${props.previousRoute}`}
      title={`Ver as informações do pedido ${props.product.orderId}`}
    >
      <MediaQuery minDeviceWidth={426}>
        <div className='order-number col-auto txt-center px-2'>
          <div className='row align-items-center h-100'>
            <div className='col-12'>
              <p className='txt-font-body txt-body-sm color-ui-2 mt-1'><strong>{props.product.parentOrderId ? `#${props.product.parentOrderId}` : ''}</strong></p>
            </div>
          </div>
        </div>
      </MediaQuery>
      <div className='order-img col-3 col-sm-2 txt-center pl-0 pr-2'>
        <div className='row align-items-center h-100'>
          <div className='col-12 txt-center'>
            <ProductImage
              name={props.product.name}
              alt=''
              imageUrl={props.product.imageUrl}
              vendorId={props.product.vendorId}
              vendorType={props.product.vendorType}
              ready={props.ready}
            />
          </div>
          <MediaQuery maxDeviceWidth={425}>
            <div className='col-12 txt-center'>
              <p className='txt-font-body txt-subtitle color-ui-2 mt-1'><strong>{props.product.parentOrderId ? `#${props.product.parentOrderId}` : ''}</strong></p>
            </div>
          </MediaQuery>
        </div>
      </div>
      <div className='order-product-info col mr-auto'>
        <div className='order-product-info row'>
          <ProductDetails
            trackingStatus={props.product.trackingStatusDescription}
            name={props.product.name}
            sellingPrice={props.product.sellingPrice}
            quantity={props.product.quantity}
            deliveryDate={props.product.deliveryDate}
            vendorName={props.product.vendorName}
            vendorType={props.product.vendorType}
            ready={props.ready}
            orderPaymentDetailMoneyAndPoints={props.product.orderPaymentDetailMoneyAndPoints}
            paymentType={props.product.paymentType}
            costPrice={props.product.costPrice}
            packageSize={props.packageSize}
          />
        </div>
      </div>
      <div className='order-action pos-relative col-3 txt-center d-none d-md-block'>
        <div className='row align-items-center h-100'>
          <ViewProdutOrderDetail
            parentOrderId={props.product.parentOrderId}
            orderId={props.product.orderId}
            productId={props.product.id}
            ready={props.ready}
            previousRoute={props.previousRoute}
          />
        </div>
      </div>
    </Link>
  </div>
)

ProductOrderItem.propTypes = {
  product: PropTypes.object,
  ready: PropTypes.bool,
  previousRoute: PropTypes.string,
  packageSize: PropTypes.number
}

export default ProductOrderItem



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ProductOrderItem.js